import config from "config";
import { APICore } from "helpers/api/apiCore";
import { FilterMetadata } from "redux/types";
import { CheckerRemark, GetSingleRecordById, reviewBulkRepayment } from "./types";

const api = new APICore();

function createRepaymentInstrumentBulkRequestApi(params: any) {
  let formData = new FormData();

  Object.keys(params).forEach(key => {
    formData.append(key, params[key]);
  });
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayments-instrument-bulk-request/repayment-instrument-based/file`;
  return api.create(baseUrl, formData);
}

function fetchRepaymentInstrumentBulkRequestApi(params: FilterMetadata) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayments-instrument-bulk-request`;
  return api.get(`${baseUrl}`, params);
}

function fetchRepaymentInstrumentBulkRequestDetailApi(params: GetSingleRecordById) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayments-instrument-bulk-request/${params.externalId}`;
  return api.get(`${baseUrl}`, {});
}

function fetchRepaymentInstrumentBulkRequestVersionApi(params: GetSingleRecordById) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-instrument-bulk-request-actions/${params.externalId}/action/versions`;
  return api.get(`${baseUrl}`, {});
}

function approveRepaymentInstrumentBulkRequestApi(params: CheckerRemark) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-instrument-bulk-request-actions/${params.externalId}/approve`;
  return api.updatePatch(`${baseUrl}`, remarks);
}

function rejectRepaymentInstrumentBulkRequestApi(params: CheckerRemark) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-instrument-bulk-request-actions/${params.externalId}/reject`;
  return api.updatePatch(`${baseUrl}`, remarks);
}

function fetchRepaymentInstrumentBulkRequestsSettledEntriesApi(params: { filters: FilterMetadata; externalId: string }) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-settlement-instrument-bulk-entries/${params.externalId}`;
  return api.get(`${baseUrl}`, params.filters);
}

function fetchRepaymentInstrumentBulkRequestsSettledEntriesDetailApi(params: GetSingleRecordById) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-settlement-instrument-bulk-entries/${params.externalId}`;
  return api.get(`${baseUrl}`, {});
}

function reviewRepaymentInstrumentBulkRequestApi(params: reviewBulkRepayment) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-instrument-bulk-request-actions/${params.versionRecordId}/reviewBulkRepayment`;
  return api.updatePatch(`${baseUrl}`, params.reviewPayload);
}

function fetchRepaymentInstrumentBulkRequestAuaditApi(params: FilterMetadata) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/action-audit`;
  return api.get(`${baseUrl}`, params);
}


export {
  createRepaymentInstrumentBulkRequestApi,
  fetchRepaymentInstrumentBulkRequestApi,
  fetchRepaymentInstrumentBulkRequestDetailApi,
  approveRepaymentInstrumentBulkRequestApi,
  rejectRepaymentInstrumentBulkRequestApi,
  fetchRepaymentInstrumentBulkRequestVersionApi,
  fetchRepaymentInstrumentBulkRequestsSettledEntriesApi,
  fetchRepaymentInstrumentBulkRequestsSettledEntriesDetailApi,
  reviewRepaymentInstrumentBulkRequestApi,
  fetchRepaymentInstrumentBulkRequestAuaditApi
};
